<template>
  <div id="lazy-gallery" class="md-layout md-gutter" :class="[{ 'third-gallery' : numberOfItems===3}]">
    <SLazyCard v-for="item of numberOfItems" :key=item  />
  </div>
</template>

<script>
import SLazyCard from "@/material-components/organisms/SLazyCard";
export default {
  name: "SLazyContent",
  props: ["numberOfItems"],
  components: {
    SLazyCard,
  },
};
</script>


<style lang="scss" scoped>
#lazy-gallery {
  display: flex;
  flex-wrap: wrap;
}
#lazy-gallery > div {
  flex: 50%;
  box-sizing: border-box;
}
.third-gallery > div {
  flex: 33.33% !important;
}
</style>
